import { useQuery, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import { getExpertBios } from "#/lib/contentful/contentfulClient"
import { ExpertBio, mapContentToExpertBio } from "#/components/read/shared/ExpertBioMapper"

import { carrotClient } from "#/utils/CarrotClient"

export type CareTeamExpertDetail = {
  reasonId: number
  locationId: number
  contentfulTileEntryId: string
}

export type CareTeamExpertResponse = {
  timeTapStaffId: number
  services: CareTeamExpertDetail[]
}

const QUERY_KEY = ["care-team-experts"]

export function useCareTeamExperts(): UseQueryResult<CareTeamExpertResponse[], ResponseError> {
  return useQuery<CareTeamExpertResponse[], ResponseError>(QUERY_KEY, () => carrotClient.getCareTeamExperts(), {
    refetchOnWindowFocus: false
  })
}

const EXPERT_BIOS_QUERY_KEY = ["expert-bios"]

export function useExpertBios(): UseQueryResult<ExpertBio[], ResponseError> {
  return useQuery<ExpertBio[], ResponseError>(
    EXPERT_BIOS_QUERY_KEY,
    async () => {
      const bios = await getExpertBios()
      return bios.map(mapContentToExpertBio)
    },
    {
      refetchOnWindowFocus: false
    }
  )
}
